import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxFixedDirective } from './directvives';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxFixedDirective,
    ],
    exports: [
        AtxFixedDirective,
    ],
})

export class AtxFixedModule {}
